import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputDateUI from '../../../widgets/form/InputDateUI'
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputSelectUI from '../../../widgets/form/InputSelectUI'
import InputReadOnlyUI from '../../../widgets/form/InputReadOnlyUI'

const CompanyNameUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  //
  cinName, onNameChange, nameError, setNameError,
  incorporationDate, onIncorporationDateChange, incorporationDateError, setIncorporationDateError,
  cinNumber, onCinNumberChange, cinNumberError, setCinNumberError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update Name in CIN'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='cinName' label='Name in CIN'
      value={cinName} onChange={onNameChange}
      error={nameError} setError={setNameError}
    />
    <InputTextSF type='text' name='cinNumber' label='CIN Number'
      value={cinNumber} onChange={onCinNumberChange}
      error={cinNumberError} setError={setCinNumberError}
    />
    <InputDateUI context={context} type='date' name='incorporationDate' label='Incorporation date'
      selectedDateISO={incorporationDate} onChange={onIncorporationDateChange}
      error={incorporationDateError} setError={setIncorporationDateError}
    />
  </ModalFormUI>

export default CompanyNameUpdateModalUI
